React = require('react/addons')

module.exports = React.createClass
    mixins: [React.addons.LinkedStateMixin]
    getInitialState: ->
        {
            isInEditPhase: false
            description: @props.description
        }

    onEditRequest: (e) ->
        e.preventDefault()

        @setState({
            isInEditPhase: true
        }, () -> @refs.content.getDOMNode().focus())
    
    onEdit: (e) ->
        e.preventDefault()

        @setState({
            isInEditPhase: false
        }, () ->
            @props.editItem({
                name: @props.name
                description: @state.description
            })
        )

    render: ->
        editState    = React.createElement("svg", {"onClick": (@onEditRequest), "dangerouslySetInnerHTML": ({__html: '<use xlink:href="#icon-edit">'})})
        contentState = React.createElement("div", {"className": "content-wrapper"}, React.createElement("textarea", {"ref": "content", "className": "content", "disabled": "disabled", "value": (@props.description)}))

        if @state.isInEditPhase
           editState    = React.createElement("svg", {"onClick": (@onEdit), "dangerouslySetInnerHTML": ({__html: '<use xlink:href="#icon-ok">'})})
           contentState = React.createElement("div", {"className": "content-wrapper"}, React.createElement("textarea", {"ref": "content", "className": "content editing", "valueLink": (@linkState('description'))}))

        React.createElement("div", {"className": "item"},
            React.createElement("div", {"className": "header"}, (@props.name)),
            (contentState),
            React.createElement("div", {"className": "actions"},
                React.createElement("svg", {"onClick": (@props.onDelete), "dangerouslySetInnerHTML": ({__html: '<use xlink:href="#icon-remove">'})}),
                (editState)
            )
        )




/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/modules/event-item.cjsx
 **/